module.exports = __webpack_public_path__ + "media/images/lb/932-b869d3f305fe8dea81af7e967d06904a.svg";